export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'OrgHeader',
  props: {},
  data() {
    return {}
  },
  methods: {},
}
